import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DriverOverviewDataInterface } from '../../models/dashboard/companyInsight/driverOverviewData';

interface IInitialState {
  driverOverviewData?: DriverOverviewDataInterface;
}

const initialState: IInitialState = {
  driverOverviewData: undefined
};

const driverOverviewDataSlice = createSlice({
  name: 'driverOverviewDataSlice',
  initialState,
  reducers: {
    setDriverOverviewData(state, action: PayloadAction<DriverOverviewDataInterface>) {
      state.driverOverviewData = action.payload;
    },
  },
});

export const driverOverviewDataActions = driverOverviewDataSlice.actions;
export default driverOverviewDataSlice.reducer;
